const NESTED_IMPROVEMENT_KEYS = [
  'basement',
  'attic',
  'fireplace',
  'garage',
  'detachedGarage',
  'carport',
  'shed',
  'workshop',
  'barn',
  'pool',
  'spa',
  'adu',
  'porch',
  'patio',
  'deck',
  'coveredPorch',
  'enclosedPatio',
  'solarPanel',
  'heatingAndCooling',
] as const;

type ImprovementRecord = Record<string, unknown>;

export const mergeArvImprovements = <T extends ImprovementRecord>(
  asIs?: T,
  arv?: T,
): T | undefined => {
  if (!arv) return asIs;
  if (!asIs) return arv;

  const merged: ImprovementRecord = { ...asIs, ...arv };

  for (const key of NESTED_IMPROVEMENT_KEYS) {
    const arvValue = arv[key];
    if (
      arvValue !== undefined &&
      typeof arvValue === 'object' &&
      arvValue !== null &&
      !Array.isArray(arvValue)
    ) {
      const asIsValue = asIs[key];
      merged[key] = {
        ...(typeof asIsValue === 'object' && asIsValue !== null && !Array.isArray(asIsValue)
          ? asIsValue
          : {}),
        ...arvValue,
      };
    }
  }

  return merged as T;
};
